/**
 * Icons.tsx — 内联 SVG 图标集合（不依赖图标库）
 */

interface IconProps {
  className?: string;
}

export function LogoIcon({ className = 'h-6 w-6' }: IconProps) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#4f46e5" />
      <path d="M20 44V20l24 12-24 12z" fill="#ffffff" />
    </svg>
  );
}

export function SearchIcon({ className = 'h-4 w-4' }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={className} aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" strokeLinecap="round" />
    </svg>
  );
}

interface HeartIconProps extends IconProps {
  filled?: boolean;
}

export function HeartIcon({ filled = false, className = 'h-5 w-5' }: HeartIconProps) {
  return (
    <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" className={className} aria-hidden="true">
      <path d="M12 21s-7.5-4.7-10-9.3C.6 8.6 2.4 5 5.9 5c2 0 3.3 1 4.1 2.2C10.8 6 12.1 5 14.1 5c3.5 0 5.3 3.6 3.9 6.7C19.5 16.3 12 21 12 21z" strokeLinejoin="round" />
    </svg>
  );
}

export function CopyIcon({ className = 'h-4 w-4' }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={className} aria-hidden="true">
      <rect x="9" y="9" width="12" height="12" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

export function CheckIcon({ className = 'h-4 w-4' }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className} aria-hidden="true">
      <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
